/* 13.10.2026 (власник): джерело відвідувача для замовлень, перший і останній дотик.
   Навіщо: замовлення йдуть через Chekly, і Shopify джерела не бачить. Скрипт Chekly
   тримає мітки лише 7 днів, перезаписує їх цілком, не передає gclid і не знає referrer.

   Що робить цей файл:
   1. На кожній сторінці читає мітки з адреси (utm_*, gclid, wbraid, gbraid, fbclid,
      ttclid, srsltid) і зовнішній referrer. Прямий захід нічого не стирає.
   2. Зберігає на 90 днів у localStorage і cookie ax_attr три записи: f (перший дотик),
      l (останній захід з мітками), r (останній зовнішній referrer).
   3. Пише це в атрибути кошика. Чекаут Chekly бере з кошика ключі, що починаються на
      utm_, а також gclid, wbraid, gbraid, fbclid, ttclid, srsltid, referrer,
      landing_page, і вони мають пріоритет над мітками з адреси.
   4. Продовжує cookie chekly_tracking до 90 днів тими самими мітками: це запасний шлях
      через адресу чекаута, якщо атрибути кошика не встигли записатись.

   Ключі в замовленні:
   utm_source, utm_medium, utm_campaign, utm_content, utm_term, utm_id  останній захід з мітками.
     Якщо в адресі був лише клік-ідентифікатор без utm, джерело виводимо з нього:
     gclid це google / cpc, fbclid це instagram або facebook / social, ttclid це tiktok / cpc,
     srsltid це google / organic_shopping; кампанія тоді «(gclid)», «(fbclid)» тощо.
     Порожні medium, campaign, content, term пишемо як «-», щоб Chekly не доклеїв туди
     значення від старішого заходу.
   gclid, wbraid, gbraid, fbclid, ttclid, srsltid  ідентифікатори того самого заходу.
   utm_touch_date   дата цього заходу.
   landing_page     сторінка входу цього заходу (шлях без параметрів).
   referrer         останній зовнішній сайт, з якого прийшли (лише домен).
   utm_first_source, utm_first_medium, utm_first_campaign, utm_first_date, utm_first_click
                    перший дотик за 90 днів; якщо міток не було, джерело з referrer
                    (google / organic, instagram / social, chatgpt.com / ai, сайт / referral).
   Звіти: utm_source лишається «останнім заходом з мітками», як і було. Замовлення без
   міток розкладаються за referrer і utm_first_*.
   Відкат: прибрати рядок підключення в layout/theme.liquid. */
(function () {
  if (window.AdaptisAttr || (window.Shopify && Shopify.designMode)) return;
  var KEY = "ax_attr", DAYS = 90, DAY = 864e5, now = Date.now();
  var UTM = { utm_source: "s", utm_medium: "m", utm_campaign: "c", utm_content: "n", utm_term: "r", utm_id: "i" };
  var CLICK = ["gclid", "wbraid", "gbraid", "fbclid", "ttclid", "srsltid"];

  function clean(v, max) { return String(v == null ? "" : v).replace(/[\u0000-\u001f]+/g, " ").trim().slice(0, max); }
  function getCookie(n) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)"));
    if (!m) return "";
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function setCookie(n, v, days) {
    try {
      document.cookie = n + "=" + v + "; path=/; max-age=" + Math.round(days * 86400) + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");
    } catch (e) {}
  }
  function parse(s) { try { var o = JSON.parse(s); return o && typeof o === "object" ? o : null; } catch (e) { return null; } }
  function ymd(t) { var d = new Date(t); return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2); }

  /* Домен, з якого прийшли. Свої сторінки, чекаут і сторінки оплати дотиком не вважаємо. */
  function refHost() {
    var r = document.referrer || "";
    if (!r) return "";
    var h = "";
    if (/^android-app:\/\//i.test(r)) h = r.replace(/^android-app:\/\//i, "").split(/[/?#]/)[0];
    else { try { h = new URL(r).hostname; } catch (e) { return ""; } }
    h = h.toLowerCase().replace(/^www\./, "");
    if (!h || h === location.hostname.replace(/^www\./, "")) return "";
    if (/(^|\.)(adaptis\.com|shopifypreview\.com|myshopify\.com|shopify\.com|chekly-app\.com)$/.test(h)) return "";
    if (/(^|\.)(monobank\.ua|privatbank\.ua|privat24\.ua|liqpay\.ua|wayforpay\.com|fondy\.eu|portmone\.com|portmone\.com\.ua|novapay\.ua|ipay\.ua|plata\.ua|pumb\.ua|oschadbank\.ua|a-bank\.com\.ua|raiffeisen\.ua|sensebank\.ua|ukrsibbank\.com|otpbank\.com\.ua)$/.test(h)) return "";
    if (/(^|\.)(3ds|acs)\d*\./.test(h) || h === "accounts.google.com" || h === "appleid.apple.com") return "";
    return clean(h, 80);
  }
  /* Домен без міток зводимо до пари «джерело / тип». */
  function classify(h) {
    var m;
    if ((m = h.match(/(^|\.)(chatgpt\.com|openai\.com|perplexity\.ai|claude\.ai|deepseek\.com|grok\.com|you\.com|phind\.com)$/))) return [m[2], "ai"];
    if (h === "gemini.google.com" || h === "copilot.microsoft.com") return [h, "ai"];
    if (/^(mail\.google\.com|com\.google\.android\.gm|mail\.ukr\.net|outlook\.live\.com|mail\.yahoo\.com)$/.test(h)) return [h, "email"];
    if (/(^|\.)google\.[a-z.]{2,6}$/.test(h) || h === "com.google.android.googlequicksearchbox") return ["google", "organic"];
    if ((m = h.match(/(^|\.)(bing|duckduckgo|yahoo|ecosia|startpage|brave)\.(com|org)$/))) return [m[2], "organic"];
    if (/(^|\.)yandex\.[a-z.]{2,6}$/.test(h)) return ["yandex", "organic"];
    if (/(^|\.)instagram\.com$/.test(h) || h === "com.instagram.android") return ["instagram", "social"];
    if (/(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$/.test(h) || h === "com.facebook.katana") return ["facebook", "social"];
    if (/(^|\.)tiktok\.com$/.test(h)) return ["tiktok", "social"];
    if (/(^|\.)(youtube\.com|youtu\.be)$/.test(h)) return ["youtube", "social"];
    if (/(^|\.)(t\.me|telegram\.org|telegram\.me)$/.test(h) || h === "org.telegram.messenger") return ["telegram", "social"];
    if (/(^|\.)(x\.com|twitter\.com|t\.co)$/.test(h)) return ["x", "social"];
    if (/(^|\.)(linkedin\.com|lnkd\.in)$/.test(h)) return ["linkedin", "social"];
    if (/(^|\.)(threads\.net|threads\.com)$/.test(h)) return ["threads", "social"];
    return [h, "referral"];
  }
  /* Захід лише з клік-ідентифікатором: джерело відоме з самого ідентифікатора. */
  function fromClick(t) {
    if (t.gclid || t.wbraid || t.gbraid) return ["google", "cpc", "(gclid)"];
    if (t.fbclid) { var c = t.h ? classify(t.h) : []; return [c[0] === "instagram" ? "instagram" : "facebook", "social", "(fbclid)"]; }
    if (t.ttclid) return ["tiktok", "cpc", "(ttclid)"];
    if (t.srsltid) return ["google", "organic_shopping", "(srsltid)"];
    return ["", "", ""];
  }
  function clickName(t) { for (var i = 0; i < CLICK.length; i++) if (t[CLICK[i]]) return CLICK[i]; return ""; }

  /* Стан: localStorage головний, cookie запасна (і навпаки, якщо одне з них стерли). */
  function load() {
    var st = null;
    try { st = parse(localStorage.getItem(KEY)); } catch (e) {}
    if (!st) st = parse(getCookie(KEY));
    st = st || {};
    ["f", "l", "r"].forEach(function (k) { if (!st[k] || typeof st[k] !== "object" || !(now - st[k].t < DAYS * DAY)) delete st[k]; });
    return st;
  }
  function save(st) {
    var full = JSON.stringify(st);
    try { localStorage.setItem(KEY, full); } catch (e) {}
    var c = encodeURIComponent(full);
    if (c.length > 3000) {
      /* Cookie має вміститись у ліміт браузера: довгі ідентифікатори лишаються в localStorage. */
      var slim = parse(full);
      ["f", "l"].forEach(function (k) { if (slim[k]) { if (slim[k].fbclid) slim[k].fbclid = slim[k].fbclid.slice(0, 40); ["c", "n", "r"].forEach(function (x) { if (slim[k][x]) slim[k][x] = slim[k][x].slice(0, 60); }); } });
      c = encodeURIComponent(JSON.stringify(slim));
      if (c.length > 3800) return;
    }
    setCookie(KEY, c, DAYS);
  }

  var st = load(), changed = false;
  var q; try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  var path = clean(location.pathname, 120), host = refHost();
  var t = { t: now, k: "url" }, marked = false;
  if (q) {
    Object.keys(UTM).forEach(function (k) { var v = clean(q.get(k), 150); if (v) { t[UTM[k]] = v; if (k !== "utm_content" && k !== "utm_term") marked = true; } });
    CLICK.forEach(function (k) { var v = clean(q.get(k), 400); if (v) { t[k] = v; marked = true; } });
  }
  if (marked) {
    t.p = path; if (host) t.h = host;
    st.l = t; changed = true;
  } else if (!st.l) {
    /* Перехідний період: мітки, які Chekly вже зберіг до появи цього скрипта. */
    var ck = parse(getCookie("chekly_tracking"));
    if (ck && (ck.utm_source || ck.gclid || ck.fbclid || ck.ttclid)) {
      var o = { t: now, k: "chekly" };
      Object.keys(UTM).forEach(function (k) { var v = clean(ck[k], 150); if (v) o[UTM[k]] = v; });
      ["gclid", "fbclid", "ttclid"].forEach(function (k) { var v = clean(ck[k], 400); if (v) o[k] = v; });
      st.l = o; changed = true;
    }
  }
  if (host) { st.r = { t: now, h: host }; changed = true; }
  if (!st.f) {
    if (st.l && (marked || st.l.k === "chekly")) { st.f = parse(JSON.stringify(st.l)); changed = true; }
    else if (host) { var cl = classify(host); st.f = { t: now, k: "ref", s: cl[0], m: cl[1], h: host, p: path }; changed = true; }
  }
  if (changed) save(st);

  /* Те, що піде в атрибути кошика. */
  function attrs() {
    var a = {}, l = st.l, f = st.f;
    if (l) {
      var d = l.s ? [l.s, l.m || "-", l.c || "-"] : fromClick(l);
      if (d[0]) {
        a.utm_source = d[0]; a.utm_medium = d[1] || "-"; a.utm_campaign = d[2] || "-";
        a.utm_content = l.n || "-"; a.utm_term = l.r || "-";
        if (l.i) a.utm_id = l.i;
      }
      CLICK.forEach(function (k) { if (l[k]) a[k] = l[k]; });
      a.utm_touch_date = ymd(l.t);
      if (l.p) a.landing_page = l.p;
    }
    if (st.r) a.referrer = st.r.h;
    if (f) {
      var fd = f.s ? [f.s, f.m || "", f.c || ""] : fromClick(f);
      if (fd[0]) {
        a.utm_first_source = fd[0];
        if (fd[1]) a.utm_first_medium = fd[1];
        if (fd[2]) a.utm_first_campaign = fd[2];
      }
      a.utm_first_date = ymd(f.t);
      var cn = clickName(f); if (cn) a.utm_first_click = cn;
    }
    return a;
  }

  /* Запасний шлях через адресу чекаута: та сама cookie, яку читає скрипт Chekly, але на 90 днів. */
  (function () {
    var l = st.l; if (!l) return;
    var o = {};
    Object.keys(UTM).forEach(function (k) { if (l[UTM[k]]) o[k] = l[UTM[k]]; });
    ["gclid", "fbclid", "ttclid"].forEach(function (k) { if (l[k]) o[k] = l[k]; });
    var left = DAYS - (now - l.t) / DAY;
    if (Object.keys(o).length && left > 0) setCookie("chekly_tracking", encodeURIComponent(JSON.stringify(o)), left);
  })();

  /* Запис в атрибути кошика: лише коли кошик уже існує і лише коли щось змінилось. */
  var busy = false, timer = null;
  function sync() {
    if (busy || !window.fetch) return;
    var token = getCookie("cart"); if (!token) return;
    var a = attrs(), keys = Object.keys(a).sort();
    var sig = token.slice(0, 40) + "|" + keys.map(function (k) { return k + "=" + a[k]; }).join("&");
    /* Позначка «вже записано» живе в localStorage; де він недоступний, у короткій cookie,
       щоб запит не повторювався на кожній сторінці. */
    var h = 0; for (var i = 0; i < sig.length; i++) h = (h * 31 + sig.charCodeAt(i)) | 0;
    var prev = "", old = [], ok = true;
    try { prev = localStorage.getItem(KEY + "_sync") || ""; old = (localStorage.getItem(KEY + "_keys") || "").split(",").filter(Boolean); } catch (e) { ok = false; }
    if (prev === sig || getCookie(KEY + "_s") === String(h) || (!keys.length && !old.length)) return;
    var body = {};
    old.forEach(function (k) { body[k] = ""; });
    keys.forEach(function (k) { body[k] = a[k]; });
    busy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    window.fetch(root + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: body }) })
      .then(function (r) {
        busy = false;
        if (!r || !r.ok) return;
        try { localStorage.setItem(KEY + "_sync", sig); localStorage.setItem(KEY + "_keys", keys.join(",")); } catch (e) { ok = false; }
        if (!ok) setCookie(KEY + "_s", String(h), 14);
      }, function () { busy = false; });
  }
  function later(ms) { clearTimeout(timer); timer = setTimeout(sync, ms); }

  /* Після кожного додавання в кошик атрибути дописуються одразу, не чекаючи наступної сторінки. */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var p = of.apply(window, arguments);
      try {
        var u = typeof input === "string" ? input : (input && input.url) || "";
        if (/\/cart\/add(\.js)?(\?|$)/.test(u)) p.then(function (r) { if (r && r.ok) later(120); }, function () {});
      } catch (e) {}
      return p;
    };
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { later(300); }); else later(300);
  window.addEventListener("pageshow", function (e) { if (e.persisted) later(300); });

  window.AdaptisAttr = { state: function () { return st; }, attrs: attrs, sync: sync };
})();
